/**
 * 修改库存
 */
import React, { PureComponent } from 'react';
import { Modal, Radio, message, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import styles from './InventoryModal.module.scss';
import http from '@/assets/api/http';


class Inventory extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
            inventoryNum: null,//增加库存
        };
    }

    _handleOk = () => {
        const { inventoryNum } = this.state;
        const { data } = this.props;
        if (!inventoryNum) return message.warning('请输入增加库存数');
        this.setState({ confirmLoading: true }, () => {
            http('/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.quickUpdateCoupon', {
                id: data.id,
                addLeftNum: inventoryNum,
            }, 'POST').then(() => {
                message.success('修改成功');
                this.setState({
                    visible: false,
                });
                this.props.closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '修改异常');
                this.setState({
                    confirmLoading: false
                });
            });
        });
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    inventoryHandle = (value) => {
        this.setState({ inventoryNum: value });
    }

    render() {
        const { visible, confirmLoading, title, inventoryNum } = this.state;

        return (
            <Modal
                width={520}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <div className={styles.input}>
                        <label>增加库存</label>
                        <InputNumber
                            style={{ width: '150px', margin: '0 7px' }}
                            min={1}
                            max={9999999}
                            keyboard={true}
                            value={inventoryNum}
                            placeholder='请输入'
                            onChange={this.inventoryHandle}
                        />
                        <label>张</label>
                    </div>
                    <p>只能增加不能减少，请谨慎填写</p>
                </div>
            </Modal>
        );

    }
}

Inventory.propTypes = {
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default Inventory;